import React, { useEffect, useState } from "react";
import "../../../../../Create_Assessment/Create_Question/CreateQuestionHw.css";
import AttachmentDefault from "../../../../../Create_Assessment/Create_Question/Create_Q_Type/AttachmentDefault";

export default function McqTypeScheduleQuestion({ questionNumber, question }) {
  console.log(question);
  return (
    <>
      {question ? (
        <div className="d-flex align-items-center justify-content-center">
          <div className="col-11 m-0 mt-3 p-3 question_box_container">
            <div className=" d-flex align-items-center">
              <div className="hw_question_no me-2">Q{questionNumber}</div>
              <div className="hw_question_box ">{question?.title}</div>
            </div>
            <div className=" mt-2  d-flex align-items-center hw_default_dropdown_container ">
              <div className="hw_default_dropdown_card ">
                <div className="hw_default_dropdown_box_header">
                  KNOWLEDGE DOMAIN
                </div>
                <span className="hw_default_dropdown_box_size">
                  {question?.domain?.name}
                </span>
              </div>
              <div className="hw_default_dropdown_card">
                <div className="hw_default_dropdown_box_header">SKILLS</div>
                <span className=" hw_default_dropdown_box_size">
                  {question?.skill?.name}
                </span>
              </div>
              <div className="hw_default_dropdown_card">
                <div className="hw_default_dropdown_box_header">CHAPTER</div>
                <span className=" hw_default_dropdown_box_size">
                  {question?.chapter?.name}
                </span>
              </div>
              <div className="hw_default_dropdown_card">
                <div className="hw_default_dropdown_box_header">
                  TYPE OF QUESTION
                </div>
                <span className=" hw_default_dropdown_box_size">
                  {question?.type?.name}
                </span>
              </div>
            </div>
            <div className="mt-2 hw_default_dropdown_container d-flex align-ites-center justify-content-between ">
              <div className="d-flex align-items-center gap-5">
                <div className="hw_mandatory_checkbox ">
                  <input
                    checked={question?.is_mandatory}
                    readOnly
                    type="checkbox"
                  />
                  &nbsp;
                  <span>Mandatory question</span>
                </div>
                <div className="hw_mandatory_checkbox ">
                  <input
                    checked={question?.add_to === "homework"}
                    readOnly
                    type="checkbox"
                  />
                  &nbsp;
                  <span>Add for Assessment</span>
                </div>
              </div>

              <div className="gap-3 time_duration_box d-flex justify-content-between ">
                <div className="hw_default_dropdown_card2">
                  <div className="hw_default_dropdown_box_header">MARKS</div>
                  <span className="hw_default_dropdown_box_size">
                    {question?.correct_score}
                  </span>
                </div>
                <div className="hw_default_dropdown_card2">
                  <div className="hw_default_dropdown_box_header">
                    LEVEL OF DIFFICULTY
                  </div>
                  <span className="hw_default_dropdown_box_size">
                    {question?.difficulty_level?.name}
                  </span>
                </div>
              </div>
            </div>

            {question?.attachments?.length > 0 &&
              question?.attachments?.map((attachment, index) => (
                <div
                  key={index}
                  className=" mt-2 hw_default_dropdown_container d-flex "
                >
                  <AttachmentDefault
                    attach={attachment}
                    fileSize={question.attachments_sizeKb[index]}
                  />
                </div>
              ))}

            {question?.options?.length > 0 &&
              question?.options?.map((option, index) => (
                <div key={index} className="d-flex mb-3 col-11 mt-3">
                  <div className="hw_question_no me-2">{option?.key}</div>
                  <div className="hw_mcq_option_box">{option?.value}</div>
                </div>
              ))}

            {question?.correct_answers?.length > 0 && (
              <div className=" ml-3 mb-3 col-12 ">
                <div className="hw_select_ans ml-2 mb-2">Correct answer</div>
                {question?.correct_answers?.map((answer, index) => (
                  <div className="d-flex mb-3 col-12 ml-1 p-0 ">
                    <div key={index} style={{ width: "100%" }}>
                      <div style={{ width: "96.3%" }}>
                        <div className="hw_mcq_answer_option_box ">
                          <span className="col-1 px-5 d-flex align-items-center justify-content-center select_option_dropdown   ">
                            {answer.option_key}
                          </span>
                          <div className="col-10 hw_correct_ans_option ">
                            {answer.value}
                          </div>
                        </div>
                      </div>

                      {answer?.reason_for_answer && (
                        <>
                          <div className="hw_mandatory_checkbox ml-1 mt-3">
                            Add reason for correct answer
                          </div>
                          <div style={{ width: "96.6%" }}>
                            <div className="hw_mcq_option_box mt-2 ">
                              {answer.reason_for_answer.explanation}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
